module.exports = __webpack_public_path__ + "static/Disco-swing-f76687224a861028df4448527e3abe1f.jpg";